const query = `query($numOrders: Int!, $cursor: String) {
    customer {
        orders (first: $numOrders, after: $cursor, reverse: true) {
            edges {
                node {
                    id
                    name
                    number
                    createdAt
                    cancelledAt
                    cancelReason
                    updatedAt
                    refunds {
                        createdAt
                    }
                    fulfillments (first: 10) {
                        edges {
                            node {
                                id
                                fulfillmentLineItems (first: 10) {
                                    edges {
                                        node {
                                            lineItem {
                                                image {
                                                    url
                                                    width
                                                    height
                                                }
                                                productType
                                                title
                                                variantId
                                            }
                                        }
                                    }
                                }
                                latestShipmentStatus
                                status
                                updatedAt
                                trackingInformation {
                                    url
                                }
                            }
                        }
                    }
                    lineItems (first: 10) {
                        edges {
                            node {
                                id
                                productId
                                image {
                                    url
                                }
                                price {
                                    amount
                                    currencyCode
                                }
                                variantId
                                title
                                refundableQuantity
                            }
                        }
                    }
                    totalPrice {
                        amount
                        currencyCode
                    }
                    totalRefunded {
                        amount
                        currencyCode
                    }
                    shippingAddress {
                        zip
                    }
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
}`

export default query
